import { render, staticRenderFns } from "./datas.vue?vue&type=template&id=7583e872"
import script from "./datas.vue?vue&type=script&lang=js"
export * from "./datas.vue?vue&type=script&lang=js"
import style0 from "./datas.vue?vue&type=style&index=0&id=7583e872&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports